/**
 * Root Reducer for the Everest application.
 * This combines the reducers from all applications to a single root reducer
 */
import { combineReducers } from 'redux-immutablejs';
import { createResponsiveStateReducer } from 'ctm-redux-responsive';
import Immutable from 'immutable';

import {
    createTokensReducer,
    createErrorReducer,
    createJourneyReducer,
    createPageReducer,
    createReadOnlyReducer
} from 'ctm-vertical-base';

import { configModel } from './app_config_model';
import {
    pageInitialState,
    breakpoints
} from './constants';

/**
 * The client Root Reducer object.
 * Note: The browser reducer object needs to be at the root level in order
 * for the responsive state reducer to correctly work during the build
 * step vertical specific reducers are added to a vertical namespace
 * e.g. energy.quote.something
 */
const rootReducer = {
    /**
     * Used for server configuration i.e. Port and back-end URL's
     */
    serverConfig: createReadOnlyReducer(),

    /**
     * The 'browser' reducer and breakpoint size configuration
     */
    browser: createResponsiveStateReducer(breakpoints),

    /**
     * Used for showing a modal on internal and server error.
     */
    error: createErrorReducer(Immutable.Map({
        internalError: null,
        serverError: null
    })),

    /**
     * Used to store some page details
     * i.e.transitioningToNewPage, showPleaseWait, location, title, vertical name
     */
    page: createPageReducer(pageInitialState),

    /**
     * Used for the XHR authentication and the transaction details.
     */
    user: combineReducers({
        tokens: createTokensReducer(Immutable.Map({})),
        journey: createJourneyReducer(Immutable.Map({})),
        isInternalUser: createReadOnlyReducer(),
        isAutomatedTest: createReadOnlyReducer()
    }),

    /**
     * Reducers set in the configuration model.
     */
    ...configModel.reducers
};

// combine and export our reducer config
export default combineReducers(
    rootReducer
);
